/*import axios from "axios";

const api = axios.create({
  baseURL: "https://backend.gadimart.in/api/v1/admin",
  withCredentials: true,
});

export default api;*/



import axios from "axios";

const ENV_URLS = {
  development: "https://staging.gadimart.in/api/v1/admin",
  production: "https://backend.gadimart.in/api/v1/admin",
};

export const getCurrentEnv = () => {
  return localStorage.getItem("dashboard_env") || "production";
};

export const setDashboardEnv = (env) => {
  localStorage.setItem("dashboard_env", env);
  window.location.href = "/"; // force re-login since cookies are domain-specific
};

const api = axios.create({
  baseURL: ENV_URLS[getCurrentEnv()],
  withCredentials: true,
});

export default api;